import { Dtos, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../utils/request";
import { accountCompaniesQueryKey, accountQueryKey } from "./account.keys";

export const useCreateAccountCompany = (accountId: SuretyAccountId) => {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const companiesQueryKey = accountCompaniesQueryKey(accountId);

	const mutation = useMutation({
		mutationFn: ({ data }: { data: Dtos.Company.Create.Request; onSuccess?: () => void }) =>
			post<Dtos.Company.Get.Response>(`/v2/surety/accounts/${accountId}/companies`, data),
		onSuccess: (_data, variables) => {
			queryClient.invalidateQueries({ queryKey: companiesQueryKey });
			queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) });
			variables.onSuccess?.();
		},
	});

	return {
		createAccountCompany: mutation.mutate,
		createAccountCompanyIsLoading: mutation.isPending,
		createAccountCompanyError: mutation.error,
	};
};
